package com.bikompanion.ui.strings

val EsBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Reintentar"
    override val actionClose = "Cerrar"
    override val actionSubmit = "Enviar"
    override val detailsLabel = "Detalles"
    override val detailsShow = "Mostrar detalles"
    override val detailsHide = "Ocultar detalles"
    override val actionGetDirections = "Cómo llegar"
    override val actionShareStation = "Compartir estación"
    override val linkCopied = "Enlace copiado"
    override val locateShow = "Mostrar mi ubicación"
    override val locateFollowHeading = "Seguir mi orientación"
    override val locateStopFollowing = "Dejar de seguirme"
    override val settingsTitle = "Ajustes"
    override val actionBack = "Atrás"
    override val settingsAppearance = "Apariencia"
    override val settingsLanguage = "Idioma"
    override val languageSystem = "Predeterminado del sistema"
    override val themeSystem = "Sistema"
    override val themeLight = "Claro"
    override val themeDark = "Oscuro"
    override val settingsNotifications = "Notificaciones"
    override val stationAlerts = "Alertas de estaciones"
    override val notificationsOn = "Activadas: te avisaremos cuando una estación vigilada tenga una bici"
    override val notificationsOff = "Desactivadas: las estaciones vigiladas no pueden avisarte"
    override val notificationsBlocked = "Bloqueadas: permite las notificaciones en los ajustes del sitio de tu navegador"
    override val actionManage = "Gestionar"
    override val actionTurnOn = "Activar"
    override val settingsSupport = "Ayuda"
    override val sendFeedback = "Enviar comentarios"
    override val sendFeedbackDescription = "Cuéntanos un problema o un dato incorrecto de una estación"
    override val shareApp = "Compartir la app"
    override val settingsAbout = "Acerca de"
    override val aboutApp = "Acerca de Bikompanion"
    override val aboutDevelopedBy = "Desarrollada por Tiago Araujo"
    override val aboutDataSources = "Fuentes de datos"
    override val sourceCityBikesDescription = "Redes de bicis compartidas de todo el mundo"
    override val sourceGbfsTitle = "Feeds GBFS de los operadores"
    override val sourceGbfsDescription = "Datos en directo de las estaciones de los operadores"
    override val sourceOsmTitle = "Colaboradores de OpenStreetMap"
    override val sourceOsmDescription = "Aparcabicis y datos del mapa"
    override val sourceCartoDescription = "Mosaicos del mapa"
    override val aboutLegal = "Legal"
    override val licensesTitle = "Licencias de código abierto"
    override val privacyPolicy = "Política de privacidad"
    override val deleteRatings = "Borrar mis valoraciones"
    override val deleteRatingsDescription = "Nos envía tu identificador anónimo por correo para que las borremos"
    override val licensesLoadFailed = "No se pudo cargar la lista de licencias"
    override val aboutVersion = { version: String -> "Versión $version" }
    override val issueFlatTire = "Rueda pinchada"
    override val issueFrontBrake = "El freno delantero no funciona"
    override val issueRearBrake = "El freno trasero no funciona"
    override val issueChain = "La cadena se sale"
    override val issueGears = "Las marchas no cambian"
    override val issueSeat = "Sillín dañado o ausente"
    override val issueLights = "Las luces no funcionan"
    override val issueLockOrBasket = "Candado o cesta dañados"
    override val issueFrame = "Cuadro dañado"
    override val issueMotor = "El motor eléctrico no funciona"
    override val issueBattery = "La batería no carga"
    override val issueOther = "Otro"
    override val networksLoadFailed = "No se pudieron cargar las redes de bicis. Comprueba tu conexión."
    override val parkingLoadFailed = "No se pudo cargar el aparcamiento de bicis"
    override val parkingLoading = "Buscando aparcamiento de bicis…"
    override val stationsLoading = "Cargando estaciones de bicis…"
    override val noNetworkHereTitle = "Aquí no hay bicis compartidas"
    override val noNetworkHereHint = "Aleja el mapa para encontrar la red más cercana"
    override val installTitle = "Instala Bikompanion"
    override val installHintIos = "Toca Compartir y luego Añadir a pantalla de inicio."
    override val installHintAndroid = "Consigue la app en Google Play."
    override val actionInstall = "Instalar"
    override val parkingTypeStands = "Aparcabicis"
    override val parkingTypeShed = "Caseta para bicis"
    override val parkingTypeLockers = "Taquillas para bicis"
    override val parkingTypeBuilding = "Edificio para bicis"
    override val parkingTypeOther = "Aparcamiento de bicis"
    override val fieldAddress = "Dirección"
    override val fieldCovered = "Cubierto"
    override val fieldYes = "Sí"
    override val fieldNo = "No"
    override val fieldId = "ID"
    override val fieldStationId = "ID de estación"
    override val fieldCoordinates = "Coordenadas"
    override val fieldCapacity = "Capacidad"
    override val fieldNetwork = "Red"
    override val fieldName = "Nombre"
    override val fieldCity = "Ciudad"
    override val fieldCountry = "País"
    override val fieldCompany = "Empresa"
    override val fieldLicense = "Licencia"
    override val fieldLicenseUrl = "URL de la licencia"
    override val availabilityBikes = "Bicis"
    override val availabilityElectric = "Eléctricas"
    override val availabilityEmpty = "Libres"
    override val bicingNextPickup = { p0: String -> "Próxima recogida de Bicing en $p0" }
    override val rateTitle = "Consulta o valora una bici"
    override val rateFindingNetworks = "Buscando redes de bicis cerca de ti…"
    override val rateWhatsWrong = "¿Qué le pasa?"
    override val rateBikeNumber = "Número de bici"
    override val rateElectricBike = "Bici eléctrica"
    override val rateVoteBad = "Mala"
    override val rateVoteGood = "Buena"
    override val rateWhichNetwork = "¿De qué red es esta bici?"
    override val refreshRateLimited = "Límite de solicitudes alcanzado; reintentando automáticamente"
    override val refreshFailed = "No se pudo actualizar"
    override val refreshNextUpdate = { p0: Int -> "Próxima actualización en $p0 s" }
    override val refreshUpdating = "Actualizando…"
    override val dataNone = "Aún no hay datos"
    override val dataAgeJustNow = "Datos de hace un momento"
    override val dataAgeMinutes = { p0: Int -> "Datos de hace $p0 min" }
    override val dataAgeHours = { p0: Int -> "Datos de hace $p0 h" }
    override val dataAgeDays = { p0: Int -> "Datos de hace $p0 d" }
    override val actionOpenOperator = { p0: String -> "Abrir $p0" }
    override val watchNormal = "Vigilar bicis normales"
    override val watchElectric = "Vigilar bicis eléctricas"
    override val watchInstallNormal = "Instala la app para vigilar bicis normales"
    override val watchInstallElectric = "Instala la app para vigilar bicis eléctricas"
    override val watchStopNormal = "Dejar de vigilar bicis normales"
    override val watchStopElectric = "Dejar de vigilar bicis eléctricas"
    override val actionCheckRateBike = "Consultar / Valorar bici"
    override val layerStations = "Estaciones"
    override val layerParking = "Aparcabicis"
    override val mapLabelBikes = { p0: Int -> "$p0 bicis" }
    override val mapLabelEbikes = { p0: Int -> "$p0 eléctricas" }
    override val mapLabelFree = { p0: Int -> "$p0 libres" }
    override val scoreHeadline = { p0: String, p1: String -> "Bici $p0 · $p1" }
    override val scoreNoRatings = "Aún no hay valoraciones. Puedes añadir la primera."
    override val scoreLooksGood = "Tiene buena pinta."
    override val scoreHasProblems = "Otras personas han tenido problemas con esta bici."
    override val scoreMixed = "Opiniones dispares."
    override val ratingNetworkRequired = "Primero elige a qué red pertenece esta bici."
    override val ratingThanks = { p0: String -> "¡Gracias por valorar la bici $p0!" }
    override val ratingCooldown = { p0: Int -> "Ya valoraste esta bici hace poco. Inténtalo de nuevo en $p0 min." }
    override val ratingQueued = "Guardado: lo enviaremos cuando vuelvas a tener conexión."
    override val ratingInvalidBike = "Ese número de bici no es válido para esta red."
    override val ratingRejected = "No se pudo guardar la valoración. Inténtalo más tarde."
    override val notificationFoundTitle = "Bici disponible"
    override val notificationFoundNormal = { p0: String -> "Bici normal disponible en $p0" }
    override val notificationFoundElectric = { p0: String -> "Bici eléctrica disponible en $p0" }
    override val notificationExpiredTitle = "Vigilancia de estación finalizada"
    override val notificationExpiredNormal = { p0: String -> "Se dejó de vigilar bicis normales en $p0 tras 30 minutos" }
    override val notificationExpiredElectric = { p0: String -> "Se dejó de vigilar bicis eléctricas en $p0 tras 30 minutos" }
    override val channelWatchAlertsName = "Avisos de vigilancia de estaciones"
    override val channelWatchAlertsDescription = "Disponibilidad de bicis y novedades de las estaciones vigiladas"
    override val channelBackgroundWatchName = "Vigilancia de estaciones en segundo plano"
    override val notificationWatchingTitle = "Vigilando estaciones de bicis"
    override val notificationWatchingText = "Vigilando las estaciones elegidas en segundo plano"
    override val scoreFewRatings = { count: Int ->
        singularOrPlural(
            count,
            "Solo $count valoración por ahora.",
            "Solo $count valoraciones por ahora.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "$percent% positivo en $count viaje reciente",
            "$percent% positivo en los últimos $count viajes",
        )
    }
}
